<template>
  <div class="card">
    <header class="card-header">
      <h1 style="text-align:center;">株式会社robottte プライバシーポリシー</h1>
    </header>
    <div class="card-content">
      <div class="content" style="text-align:left !important;">
        <h4 style="margin-top:1em; margin-bottom:0.5em;">株式会社ｒｏｂｏｔｔｔｅ（以下「当社」といいます）は、個人情報保護の重要性に鑑み、「個人情報の保護に関する法律」（以下「個人情報保護法」といいます）を遵守し、お客様からご提供いただいた個人情報を適切に取り扱い、お客様のプライバシーの保護に努めます。</h4>
        <h4 style="margin-top:1em; margin-bottom:0.5em;">1. 会社の名称・住所・代表者の氏名について</h4>
        <p style="text-indent:1em;">
          株式会社robottte<br>
          〒107-0062 東京都港区南青山二丁目2番15号ウィン青山942<br>
          代表取締役社長　髙𣘺　健一
        </p>

        <h4 style="margin-top:1em; margin-bottom:0.5em;">2. 個人情報の収集について</h4>
        <p style="text-indent:1em;">当社は以下の情報を収集します：</p>
        <ul>
          <li>（1）当社の提供するサービスにて当社がお客様から取得する情報
            <ul>
              <li>当社または当社サービス導入企業（無料トライアル等、一時的に当社サービスの利用を許諾された企業を含みます。以下同じ）が定める入力フォームにお客様が入力またはアップロードする個人情報（個人情報保護法第２条第１項により定義される個人情報をいい、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別することができるものを含みます（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含みます））</li>
              <li>当社サービスにアクセスしたお客様が当社サービス上で入力または送信した情報（個人情報を含みます）</li>
              <li>当社サービスにアクセスしたお客様のアクセスログ、アクションログ</li>
              <li>当社サービスにアクセスしたお客様の通信状況および接続端末に関する情報</li>
            </ul>
          </li>
          <li>（2）当社が取得した情報に基づき新たに生成する情報
            <ul>
              <li>収集した個人データを基に分析・解析されたデータ（以下「解析結果データ」といいます）のうち、特定の個人を識別することができる情報</li>
            </ul>
          </li>
          <li>（3）当社サービス導入企業から間接的に取得する情報
            <ul>
              <li>採用選考に関するお客様の情報（応募先企業・職種に関する情報、採用選考における評価情報を含みます）</li>
              <li>当社サービス導入企業の社内におけるお客様の人事に関する情報</li>
              <li>その他選考に関するお客様の当該選考等に関する情報および当社サービス導入企業から当社に開示または提供されたその他の情報</li>
            </ul>
          </li>
          <li>（4）第三者から間接的に取得する情報
            <ul>
              <li>当社の委託先である第三者から当社に開示または提供されたお客様に関する情報（お客様へのフィードバックの内容を含みます）</li>
            </ul>
          </li>
        </ul>

        <h4 style="margin-top:1em; margin-bottom:0.5em;">3. 個人情報の利用目的等について</h4>
        <p style="text-indent:1em;">（1）当社は、個人情報の利用目的を特定し、その目的以外で個人情報を利用しません。</p>
        <p style="text-indent:1em;">（2）当社が個人情報を取得する場合には、以下の目的のために利用させていただきます。</p>
        <ul>
          <li>ア　お客様に関する個人情報
            <p>【利用目的】</p>
            <ul>
              <li>お客様の本人確認・個人認証</li>
              <li>お客様のお問合せ・ご相談・苦情・修理・サポートへの対応、確認及び記録</li>
              <li>商品の開発その他サービスの改善・向上</li>
              <li>当社の提供するデジタル・サービス（ウェブサイトなど）におけるお客様の体験の改善・向上</li>
              <li>ご案内状・電子メール等による商品・サービス・キャンペーン等の広告・情報提供</li>
              <li>お客様に当社の商品・サービスを安全に提供するため。利用規約に違反している利用者の発見と当該利用者への通知や、サービス等を悪用した詐欺や不正アクセス等の不正行為を調査・検出・予防、及びこれらに対応することが含まれます。</li>
              <li>個人情報の属性の集計、分析、統計資料作成のため（統計資料とは、個人が識別・特定できないように加工したものをいい、新規サービスの開発等の業務の遂行のために利用、処理することがあります。また、統計資料を業務提携先に提供することがあります。）</li>
              <li>上記利用目的に付随する行為のため</li>
            </ul>
          </li>
          <li>イ　お取引先様（法人のお客様の場合はその役職員の皆様）に関する個人情報
            <p>【利用目的】</p>
            <ul>
              <li>業務上必要なご連絡、契約の履行、商談等のため</li>
              <li>取引先情報の管理のため</li>
            </ul>
          </li>
          <li>ウ　採用・募集活動応募者様に関する個人情報
            <p>【利用目的】</p>
            <ul>
              <li>採用・募集活動応募者様への連絡・情報提供、その他採用・募集活動に必要な利用</li>
            </ul>
          </li>
          <li>エ　従業員の皆様に関する個人情報
            <p>【利用目的】</p>
            <ul>
              <li>従業員の皆様への業務連絡</li>
              <li>従業員皆様への報酬（賃金・賞与・諸手当等）支払い、人事・労務管理の履行、福利厚生の提供</li>
              <li>従業員の皆様の健康管理</li>
            </ul>
          </li>
        </ul>
        <p style="text-indent:1em;">（3）当社は、個人情報の収集に際し、利用目的等を偽る等、不正な手段によってお客様から個人情報を収集することはいたしません。また、適正な手段により収集した個人情報を不適正な方法で利用をすることもいたしません。お客様よりご提供いただきました個人情報は、法令の定めのある場合を除いて、お客様の事前のご同意をいただくことなく、予め明示した利用目的以外には使用しません。</p>

        <h4 style="margin-top:1em; margin-bottom:0.5em;">4. 個人データの安全管理について</h4>
        <p style="text-indent:1em;">当社では、お客様よりご提供いただきました個人情報を厳重に保管、管理し、個人データ（個人情報保護法第2条第4項に定める個人情報データベース等を構成する個人情報をいいます。以下同じ）の漏洩、滅失、毀損を防止するため、法令に従って必要かつ適切な安全管理措置を講じます。当社は、利用目的の達成に必要な範囲内において、個人データを正確かつ最新の内容に保つよう努力するものとします。また、当社は、個人データを取り扱う従業者や委託先に対しても必要かつ適切な監督を行い、万が一、個人データの漏洩、滅失、毀損等の事態が発生した場合には、法令に従って適切に対応いたします。</p>

        <h4 style="margin-top:1em; margin-bottom:0.5em;">5. 個人データの共同利用について</h4>
        <p style="text-indent:1em;">当社は、お客さま／ユーザー様の個人情報を、当社サービス導入企業と共同利用いたします。</p>

        <h4 style="margin-top:1em; margin-bottom:0.5em;">6. 個人データの第三者への開示、提供について</h4>
        <p style="text-indent:1em;">当社は、以下のいずれかに該当する場合を除いて、お客様の事前のご同意をいただくことなく、お客様の個人データを第三者に開示、提供いたしません。</p>
        <ul>
          <li>個人データの取扱いを第三者に委託する場合</li>
          <li>法令に基づく場合</li>
          <li>人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき</li>
          <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき</li>
          <li>その他法令で本人の同意が不要とされている場合</li>
        </ul>
        <h4 style="margin-top:1em; margin-bottom:0.5em;">7. クッキー（Cookie）について</h4>
        <p style="text-indent:1em;">クッキーとは、WebサーバーからWebブラウザに送信されるデータのことです。Webサーバーがクッキーを参照することでユーザーのパソコンを識別でき、効率的に当社Webサイトを利用することができます。当社は、ユーザーのプライバシーの保護、利便性の向上、広告の配信、及び統計データの取得のため、Cookieを使用します。なお、広告の配信は第三者への委託に基づき、第三者を経由して、Cookieを保存し、参照する場合があります。また、当社は、CookieやJavaScript等の技術を利用して、会員登録時等に提供いただいた情報のうち年齢や性別、職業や、居住地区など個人が特定できない属性情報（組み合わせることによっても個人が特定できないものに限られます）や、サイト内におけるユーザーの行動履歴（アクセスしたURL、コンテンツ等）を取得することがあります。ただし、Cookie及び行動履歴には個人情報は一切含まれません。お使いのWebブラウザの設定により、クッキーを無効にすることも可能です。ただし、Cookie を無効にした場合、サービス利用のためのクッキーの利用との関係では，一部のウェブサイトの機能が使用できなくなったり、一部のページが正しく表示されなくなる場合がありますのでご留意ください。</p>

        <h4 style="margin-top:1em; margin-bottom:0.5em;">8. ご注意</h4>
        <p style="text-indent:1em;">当社サービスをご利用いただく場合、お客様は当社サービスを通じて当社および当社サービス導入企業に個人情報を提供することになるため、あわせて当社サービス導入企業のプライバシーポリシー等にもご同意いただく必要があります。当社サービス導入企業における個人情報の取得、保管、管理につき、当社では責任を負いかねますのでご注意ください。</p>

        <h4 style="margin-top:1em; margin-bottom:0.5em;">9. 個人情報の取扱いに係る業務の受託について</h4>
        <p style="text-indent:1em;">当社は以下の通り個人情報を取り扱います：</p>
        <ul>
          <li>（1）当社は、(2)に定める場合を除き、当社サービス導入企業が当社サービスを通じてお客様から直接取得した個人情報および当社サービス導入企業から開示または提供を受けたお客様の情報を、当社サービス導入企業からの委託に基づき、分析・解析し、その解析結果を、当社サービス導入企業へ提供します。</li>
          <li>（2）当社は、当社が当社サービスを通じてお客様から直接取得した個人情報、および当社サービス導入企業から間接的に取得したお客様の情報を、お客様からの委託に基づき、分析・解析し、その解析結果をお客様へ提供します。</li>
        </ul>

        <!-- 第９条　メモ
        (1) のケース：

        当社（サービス提供会社）は、クライアント企業が収集した顧客の個人情報を、クライアント企業の依頼に基づいて分析します。
        分析結果はクライアント企業に提供されます。

        (2) のケース：

        当社が直接収集した顧客の個人情報や、クライアント企業から間接的に得た顧客情報を、顧客の依頼に基づいて分析します。
        分析結果は顧客に直接提供されます。


        具体例：

        (1) の例：クライアント企業が、応募者の情報を当社に提供し、応募者の傾向分析を依頼する。
        (2) の例：個人ユーザーが当社のHRモンスターを使用し、自身のデータ分析を依頼する。

        -->

        <h4 style="margin-top:1em; margin-bottom:0.5em;">10. 保有個人データに関するお問合せおよび苦情のお申し出先等について</h4>
        <p style="text-indent:1em;">当社は､個人情報の照会･訂正･利用停止･消去等のご要望があったときは､所定の手続でご本人様であることを確認のうえ､すみやかに対応します｡本プライバシーポリシーに関してご質問がある場合や権利行使される場合は､下記のお問い合わせ窓口にご連絡ください｡</p>

        <p style="text-indent:1em;">
          株式会社ｒｏｂｏｔｔｔｅ　事業基盤　個人情報保護相談窓口<br>
          住所：〒107-0062　東京都港区南青山二丁目2番15号ウィン青山942<br>
          電話番号：080-3739-9680<br>
          受付時間：月曜～金曜（祝日、年末年始は除く）9時00分～17時00分
        </p>

        <h4 style="margin-top:1em; margin-bottom:0.5em;">11. プライバシーポリシーの変更について</h4>
        <p style="text-indent:1em;">当社は、このプライバシーポリシーの全部または一部を変更する場合があります。この場合には、当社ホームページ上または当社サービスページ上において変更したプライバシーポリシーを掲載するものとします。</p>

        <p style="margin-top:1em;">制定：2022年10月1日</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ModalTerm',
  data () {
    return {
      isCardModalActive: false
    }
  }
}
</script>

<style lang="scss" scoped>
header {
  margin: 0;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  position: relative;
  height: 60px;
  padding: 10px;
  background: #AA0066;
  color: white;
  font-size: 30px;
  font-weight: 1000;
}
footer {
  margin: 0;
  justify-content: space-between;
}
.right {
  position: absolute;
  top: 0;
  right: 0;
}
.form {
  padding: 20px;
}
.body {
  width: 80%;
  max-width: 400px;
  color: #000;
  background: #fff;
  border-radius: 30px;
}
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.4s;
}
.modal-enter,
.modal-leave-to {
  opacity: 0;
}
.modal-enter-active .body,
.modal-leave-active .body {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.modal-enter .body,
.modal-leave-to .body {
  opacity: 0;
  transform: translateY(-100px);
}
</style>



// WEBPACK FOOTER //
// src/views/PrivacyPolicy/PrivacyPolicyContent.vue